import {
  DateDirection,
  DateSelectDirection,
  DateSelectorMode,
  DaySelectDirection,
  WeekSelectDirection,
} from './types'

export const dayLengthForMode = (mode: DateSelectorMode, direction: DateDirection) => {
  if (mode === DateSelectorMode.WEEK) {
    if (direction === DateSelectDirection.PREVIOUS) {
      return WeekSelectDirection.PREVIOUS
    }
    if (direction === DateSelectDirection.NEXT) {
      return WeekSelectDirection.NEXT
    }
  } else {
    if (direction === DateSelectDirection.PREVIOUS) {
      return DaySelectDirection.PREVIOUS
    }
    if (direction === DateSelectDirection.NEXT) {
      return DaySelectDirection.NEXT
    }
  }
}
